const animatePattern = () => {
	// Animate contact forms pattern
	const colors = ['#2a4971', '#c3e0f2', '#5f012f', '#c5a4b3', 'rgba(0,0,0,.0)']

	const numsquares = 85
	const squares = []

	for (let i = 0; i < numsquares; i++) {
		let square = document.createElement('div')
		square.classList.add('square')
		square.style.background = colors[Math.floor(Math.random() * colors.length)]
		square.style.border =
			'2px solid ' + colors[Math.floor(Math.random() * colors.length)]
		square.style.left = `${Math.floor(Math.random() * 100)}%`
		square.style.top = `${Math.floor(Math.random() * 100)}%`
		square.style.transform = `scale(${Math.random()})`
		square.style.width = `${Math.random()}em`
		square.style.height = square.style.width

		squares.push(square)
		$('.animatePattern').append(square)
	}

	// Keyframes
	squares.forEach((el, i) => {
		let to = {
			x: Math.random() * (i % 2 === 0 ? -11 : 11),
			y: Math.random() * 12,
		}

		el.animate(
			[
				{ transform: 'translate(0, 0)' },
				{ transform: `translate(${to.x}rem, ${to.y}rem)` },
			],
			{
				duration: (Math.random() + 1) * 1500, // random duration
				direction: 'alternate',
				fill: 'both',
				iterations: Infinity,
				easing: 'ease-in-out',
			}
		)
	})
}
export { animatePattern }
